import { forwardRef } from 'react';
import { Link as RrdLink, LinkProps } from 'react-router-dom';

import { Chip, ChipProps } from '@components/base';

export type RouterChipProps = Omit<LinkProps, 'instance'> & Omit<ChipProps, 'component'>;

export const RouterChip = forwardRef<HTMLDivElement, RouterChipProps>((props, ref) => (
  <Chip {...props} component={RrdLink} ref={ref} />
));

RouterChip.displayName = 'RouterChip';
